import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { FundProvider } from './context/FundContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <FundProvider>
          <App />
        </FundProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
